var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        { name: "show", rawName: "v-show", value: _vm.open, expression: "open" }
      ],
      class: _vm.$style.container,
      on: { click: _vm.handleCloseLightbox }
    },
    [
      _c(
        "button",
        { class: _vm.$style.closeButton },
        [
          _c("NsIcon", {
            class: _vm.$style.closeIcon,
            attrs: { "icon-name": "icon-close", size: "custom" }
          }),
          _vm._v("\n    " + _vm._s(_vm.escLabel.substring(0, 3)) + "\n  ")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: _vm.$style.contentContainer,
          on: {
            click: function($event) {
              $event.stopPropagation()
            }
          }
        },
        [
          _c("div", { class: _vm.$style.content }, [
            _vm.videoSrcTags
              ? _c("video", {
                  ref: "lightboxVideo",
                  class: _vm.$style.video,
                  attrs: { controls: "" },
                  domProps: { innerHTML: _vm._s(_vm.videoSrcTags) }
                })
              : _c(
                  "video",
                  {
                    ref: "lightboxVideo",
                    class: _vm.$style.video,
                    attrs: { controls: "" }
                  },
                  [_c("source", { attrs: { src: _vm.videoSrc } })]
                )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }